module.exports = __webpack_public_path__ + "static/testi-6-c948e2d100243109888c4eddbdcbee79.jpg";